module.exports = __webpack_public_path__ + "media/images/sp/stores/omiya/omiya_sns_06-c5b0ebd6ccc94c3676ed111353d3927a.jpg";